import { FC, useState } from 'react'

import { AccountInfo } from '@aptos-labs/wallet-adapter-react'
import { AIRDROP, CLAIM } from 'config'
import useGetUserClaim from 'hooks/useGetUserClaim'

import {
  AirdropFinished,
  AlreadyClaimed,
  AlreadyClaimedSkeleton,
  ClaimButton,
  ClaimedState,
  ClaimSkeleton,
  CountLSD,
  IsNotClaim,
  Vested,
  VestedSkeleton,
} from 'components/Claim'
import FinalClaimModal from 'components/FinalClaimModal'

import s from './s.module.scss'

type Props = {
  account: AccountInfo
  airdropStatus: AIRDROP
  onClaim: () => void
}

const Claim: FC<Props> = ({ account, airdropStatus, onClaim }) => {
  const {
    claimStatus,
    fetchBalance,
    isClaimStatusLoading,
    isUserListLoading,
    receivedClaim,
    userClaim,
    vestedBalance,
  } = useGetUserClaim(account.address)

  const [error, setError] = useState(false)

  const [isReceivedClaim, setReceivedClaim] = useState(false)

  const onReceivedClaim = (receive: boolean) => {
    setReceivedClaim(receive)
    fetchBalance()
    onClaim()
  }

  const onCloseModal = () => {
    setReceivedClaim(false)
    setError(false)
  }

  const showVested = claimStatus !== CLAIM.NOT_LISTED
  const showClaim =
    claimStatus === CLAIM.AVAILABLE || claimStatus === CLAIM.ALL_IN_ROUND_CLAIMED || claimStatus === CLAIM.UNAVAILABLE
  const showAvailableToClaim = claimStatus === CLAIM.AVAILABLE || claimStatus === CLAIM.ALL_IN_ROUND_CLAIMED

  const showUserClaim = claimStatus !== CLAIM.ALL_CLAIMED

  const showClaimButton = claimStatus !== CLAIM.ALL_CLAIMED

  const showClaimedState = claimStatus === CLAIM.ALL_CLAIMED

  const showAlreadyClaimed = claimStatus === CLAIM.ALL_IN_ROUND_CLAIMED || claimStatus === CLAIM.AVAILABLE

  const isNotClaim = claimStatus === CLAIM.NOT_LISTED

  return (
    <>
      <section className={s.wrapper}>
        {airdropStatus !== AIRDROP.HAS_FINISHED && (isUserListLoading || isClaimStatusLoading) ? (
          <div className={s.blocks}>
            <VestedSkeleton />
            <div className={s.claim}>
              <ClaimSkeleton />
            </div>
            <AlreadyClaimedSkeleton />
          </div>
        ) : (
          <>
            {airdropStatus === AIRDROP.HAS_FINISHED && <AirdropFinished />}

            {airdropStatus !== AIRDROP.HAS_FINISHED && (
              <div className={s.blocks}>
                {showVested && <Vested vestedBalance={vestedBalance} />}
                {showClaim && (
                  <div className={s.claim}>
                    {showAvailableToClaim && <span className={s.claimTitle}>Left to claim</span>}

                    {showUserClaim && <CountLSD count={userClaim} />}

                    {showClaimButton && (
                      <ClaimButton
                        disabled={
                          airdropStatus === AIRDROP.NOT_STARTED ||
                          claimStatus === CLAIM.UNAVAILABLE ||
                          claimStatus === CLAIM.ALL_IN_ROUND_CLAIMED
                        }
                        setError={setError}
                        setReceivedClaim={onReceivedClaim}
                      />
                    )}
                  </div>
                )}
                {showClaimedState && <ClaimedState count={receivedClaim} />}
                {showAlreadyClaimed && <AlreadyClaimed receivedClaim={receivedClaim} />}
                {isNotClaim && <IsNotClaim />}
              </div>
            )}
          </>
        )}
      </section>

      <FinalClaimModal
        error={error}
        isReceivedClaim={isReceivedClaim}
        onClose={onCloseModal}
        opened={isReceivedClaim || !!error}
      />
    </>
  )
}

export default Claim
